import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';

import WidgetPagination from 'common/components/pagination/WidgetPagination';
import WidgetWrapper from 'common/components/widget/WidgetWrapper';
import { getCollectionBySlug } from 'redux/collections/reducers';
import { listProducts } from 'redux/products/actions';

import Template from './collection/Template';

const CollectionWidget = (props) => {
  const { node, slug } = props;
  const [page, setPage] = useState(1);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const onError = (err) => {
      setError(err.response.data.message);
    };

    dispatch(listProducts(slug, undefined, page, onError));
  }, [dispatch, slug, page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const collectionReducer = useSelector((state) => state.collection);

  const collection = getCollectionBySlug(collectionReducer, slug);

  return ReactDOM.createPortal(
    <WidgetWrapper node={node} error={error} isLoaded={!!collection}>
      {collection && (
        <>
          <Template collection={collection} displayType="Collection" />
          <WidgetPagination
            page={page}
            recordCount={collection.productCount}
            onChange={handlePageChange}
          />
        </>
      )}
    </WidgetWrapper>,
    node
  );
};

export default CollectionWidget;
